import SearchResults from './SearchResults.jsx';

export default SearchResults;
